import { v4 as uuidv4 } from "uuid";
export class MasterModel {
    constructor() {
        this.id = uuidv4();
        this.showInListManager = true;
        this.itemsFound = 0;
    }
}
export default class ListMaster extends MasterModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
